<div class="row">
  <div class="col-12 pt-3">
    <div class="row">
      <div class="col-12 p-0" *ngIf="isDataLoaded">
        <app-wizard-head [wizardInput]="wizardInput"></app-wizard-head>
      </div>
    </div>
  </div>
  <div class="col-12 contentPortion p-0 page-header" *ngIf="isDataLoaded">
    <div class="fluid-container" *ngIf="!isSimplifyH1B">
      <!-- <div class="row pt-4 d-flex align-items-center">
        <div class="col-md-9 step-title p-0">
          <h5 class="mb-0">Provide Employer Employee Relationship</h5>
        </div>
      </div>
      <p-divider class="header-divider"></p-divider> -->


      <div class="main-body">
        <div class="row">
          <div class="col-md-12">
            <h6 class="heading p-text-bold mt-3 mb-3">Select project name from dropdown and enter project details below</h6>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-md-5">
            <label class="label d-block">Project Name</label>
            <p-dropdown appendTo="body" [options]="ListOfComanyProjects" [style]="{'width':'100%'}"
              [(ngModel)]="selectedProject" optionLabel="projectName" placeholder="Select Project"
              (onChange)="changeProject()" [disabled]="disabledControls"></p-dropdown>
          </div>
          <div class="col-md-7" *ngIf="selectedProject && selectedProject.id">
            <label class="label d-block">Save <small>(Project Details, Project Milestone, Project Staffing, Additional
                Details)</small></label>
            <button type="button" (click)="savePetition()" class="p-btn btn btn-primary mr-3">Save</button>
            <!-- <button type="button" (click)="saveMasterData()" class="p-btn btn btn-primary mr-3">Save Master Data</button> -->
          </div>
        </div>
        <div class="row">
          <div class="col-12 pb-3 mt-2 d-flex">
            <div
              [ngClass]="activeTab === 'supervisor' ? 'col tabNewSub p-2 activeNewTimeLine' : 'col tabNewSub p-2'"
              (click)="toggleMode('supervisor');handleSupervisor();">
              <div class="newAlignTab lbl-text align-tabs drafttext">
                <a><mat-icon>assignment</mat-icon>Supervisor<mat-icon
                    *ngIf="activeTab === 'supervisor'">keyboard_arrow_down</mat-icon></a>
              </div>
            </div>
            <div
              [ngClass]="activeTab === 'project-details' ? 'col tabNewSub p-2 activeNewTimeLine' : 'col tabNewSub p-2'"
              (click)="handleDetails(1, false, true, 'Project Details', '(Brief about project)', null,'project-details')">
              <div class="newAlignTab lbl-text align-tabs">
                <a><mat-icon>assignment</mat-icon>Project Details<mat-icon
                    *ngIf="activeTab === 'project-details'">keyboard_arrow_down</mat-icon></a>
              </div>
            </div>
            <div
              [ngClass]="activeTab === 'project-milestone' ? 'col tabNewSub p-2 activeNewTimeLine' : 'col tabNewSub p-2'"
              (click)="handleDetails(2, false, false, workLocationTypeCode, null, 'Enter Project Timelines','project-milestone')">
              <div class="newAlignTab lbl-text align-tabs drafttext">
                <a><mat-icon>assignment</mat-icon>Project Milestone<mat-icon
                    *ngIf="activeTab === 'project-milestone'">keyboard_arrow_down</mat-icon></a>
              </div>
            </div>
            <div
              [ngClass]="activeTab === 'project-staffing' ? 'col tabNewSub p-2 activeNewTimeLine' : 'col tabNewSub p-2'"
              (click)="handleDetails(3, false, false, workLocationTypeCode, null, 'Enter Project Staffing details','project-staffing')">
              <div class="newAlignTab lbl-text align-tabs drafttext">
                <a><mat-icon>assignment</mat-icon> Project Staffing <mat-icon
                    *ngIf="activeTab === 'project-staffing'">keyboard_arrow_down</mat-icon></a>
              </div>
            </div>
            <div
              [ngClass]="activeTab === 'additional-details' ? 'col tabNewSub p-2 activeNewTimeLine' : 'col tabNewSub p-2'"
              (click)="handleDetails(4, false, false, workLocationTypeCode, null, 'Enter Any Other Relevant Details','additional-details')">
              <div class="newAlignTab lbl-text align-tabs drafttext">
                <a><mat-icon>assignment</mat-icon> Additional Details <mat-icon
                    *ngIf="activeTab === 'additional-details'">keyboard_arrow_down</mat-icon></a>
              </div>
            </div>
            <div
              [ngClass]="activeTab === 'client-documents' ? 'col tabNewSub p-2 activeNewTimeLine' : 'col tabNewSub p-2'"
              (click)="handleDocuments(5, false, 'Upload Related Client Documents', 'PETDOCTYP','client-documents')">
              <div class="newAlignTab lbl-text align-tabs drafttext">
                <a><mat-icon>assignment</mat-icon> Client Documents <mat-icon
                    *ngIf="activeTab === 'client-documents'">keyboard_arrow_down</mat-icon></a>
              </div>
            </div>
            <div
              [ngClass]="activeTab === 'project-documents' ? 'col tabNewSub p-2 activeNewTimeLine' : 'col tabNewSub p-2'"
              (click)="handleDocuments(6, false, 'Upload Related Project Documents', 'PETPROJDOC','project-documents')">
              <div class="newAlignTab lbl-text align-tabs drafttext">
                <a><mat-icon>assignment</mat-icon> Project Documents <mat-icon
                    *ngIf="activeTab === 'generate-forms'">keyboard_arrow_down</mat-icon></a>
              </div>
            </div>
          </div>
          <div class="col-12 p-0 my-3" *ngIf="activeTab === 'supervisor' && countryList && countryList.length > 0">
            <app-supervisor-details [payload]="payload" [primaryData]="primaryData" [stepDetails]="stepDetails"
              [workLocationTypeCode]="workLocationTypeCode" [countryList]="countryList">
            </app-supervisor-details>
          </div>
          <div *ngIf="activeTab === 'project-details'">
            <app-project-details [projectList]="ListOfComanyProjects" [payload]="payload" [primaryData]="primaryData"
              [showProjectName]="showProjectName" [editorName]="editorName" [tabIndex]="selectedItem"
              [editorLabel]="editorLabel">
            </app-project-details>
          </div>

          <div *ngIf="activeTab === 'project-milestone'">
            <app-project-details [projectList]="ListOfComanyProjects" [payload]="payload" [primaryData]="primaryData"
              [stepDetails]="stepDetails" [showProjectName]="showProjectName" [editorName]="editorName" [tabIndex]="2"
              [editorLabel]="editorLabel" [simplifyH1b]="false">
            </app-project-details>
          </div>

          <div *ngIf="activeTab === 'project-staffing'">
            <app-project-details [projectList]="ListOfComanyProjects" [payload]="payload" [primaryData]="primaryData"
              [stepDetails]="stepDetails" [showProjectName]="showProjectName" [editorName]="editorName" [tabIndex]="3"
              [editorLabel]="editorLabel" [simplifyH1b]="false">
            </app-project-details>
          </div>

          <div *ngIf="activeTab === 'additional-details'">
            <app-project-details [projectList]="ListOfComanyProjects" [payload]="payload" [primaryData]="primaryData"
              [stepDetails]="stepDetails" [showProjectName]="showProjectName" [editorName]="editorName" [tabIndex]="4"
              [editorLabel]="editorLabel" [simplifyH1b]="false">
            </app-project-details>
          </div>

          <div class="w-100" *ngIf="activeTab === 'client-documents'">
            <app-client-project-documents [projectId]="selectedProject ? selectedProject.id : null"
              [primaryData]="primaryData" [stepDetails]="stepDetails"
              [documentTypeDropdownCode]="documentTypeDropdownCode" [fileUploaderName]="fileUploaderName">
            </app-client-project-documents>
          </div>

          <div class="w-100" *ngIf="activeTab === 'project-documents'">
            <app-client-project-documents [projectId]="selectedProject ? selectedProject.id : null"
              [primaryData]="primaryData" [stepDetails]="stepDetails"
              [documentTypeDropdownCode]="documentTypeDropdownCode" [fileUploaderName]="fileUploaderName">
            </app-client-project-documents>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>